import { createReducer, on } from '@ngrx/store'
import * as StageActions from './stage.actions'
import { StageState } from './stage.state'

export const initialStageState: StageState = {
   //  Event category for legend in doodles and calendar and event type in calendar
   // not very explanatory but untouchable at the moment
   eventCategories: [
      { id: 2, group: 1 },
      { id: 3, group: 1 },
      { id: 4, group: 1 },
      { id: 5, group: 1 },
      { id: 6, group: 1 },
      { id: 8, group: 7 },
      { id: 9, group: 7 },
      { id: 11, group: 10 }
   ],
   isSidebarOpen: true
}

export const stageReducer = createReducer(
   initialStageState,
   on(StageActions.loadCountriesSuccess, (state, action) => {
      return { ...state, countries: action.response }
   }),
   on(StageActions.setUser, (state, action) => {
      return { ...state, user: action.user }
   }),
   on(StageActions.setProject, (state) => {
      return { ...state, project: undefined }
   }),
   on(StageActions.setProjectSuccess, (state, action) => {
      return { ...state, project: action.project }
   }),
   on(StageActions.setStatuses, (state) => ({ ...state, statuses: undefined })),
   on(StageActions.setStatusesSuccess, (state, action) => ({ ...state, statuses: action.statuses })),
   on(StageActions.searchCRMOrganizationList, (state) => ({ ...state, fromCRMOrganizations: undefined, isLoadingCRMOrganizations: true })),
   on(StageActions.searchCRMOrganizationListSuccess, (state, action) => ({
      ...state,
      fromCRMOrganizations: action.response,
      isLoadingCRMOrganizations: false
   })),
   on(StageActions.searchCRMOrganizationListFailure, (state) => ({ ...state, isLoadingCRMOrganizations: false })),
   on(StageActions.cleanCRMOrganizations, (state) => ({
      ...state,
      fromCRMOrganizations: undefined
   })),
   on(StageActions.openSidebar, (state) => {
      return { ...state, isSidebarOpen: true }
   }),
   on(StageActions.closeSideBar, (state) => {
      return { ...state, isSidebarOpen: false }
   })
)
